import SendEmailRepository from "./SendEmailRepository"
const repositories = {
  sendEmail:SendEmailRepository,
};
export const RepositoryFactory = {
  get: (name) => repositories[name],
};
